<template>
  <register-form :can-back="true" @submit.prevent="showConfirmModal" @back="toPrivacyPolicy">
    <form-caption v-if="pageTitle" :text="pageTitle" />
    <vuex-text-form-item label="氏名" bind="name" :required="true" />
    <vuex-text-form-item label="氏名（カナ）" bind="name_kana" :required="true" />
    <vuex-email-form-item label="メールアドレス" bind="email" :required="true" />
    <vuex-licence-form-item :required="true" />
    <vuex-select-form-item label="更新回数" bind="licence_update" :options="this.$constant.LICENCE.COUNT_LIST" :nullable="false" value-key="value" />
    <vuex-postal-code-form-item :required="true" />
    <vuex-prefecture-form-item :required="true" />
    <vuex-text-form-item label="市区町村" bind="address1" :required="true" />
    <vuex-text-form-item label="番地・建物など" bind="address2" :required="true"/>
    <vuex-text-form-item label="電話番号" bind="tel" :required="true" />
    <vuex-text-form-item label="FAX番号" bind="fax" />
    <vuex-text-form-item label="会社名" bind="company_name" :required="true" />
    <vuex-text-form-item label="会社名（カナ）" bind="company_name_kana" :required="true" />
    <vuex-text-form-item label="店舗名" bind="office" />
    <vuex-text-form-item label="部署名" bind="department" />
    <vuex-textarea-form-item label="連絡先" bind="contact" />
  </register-form>
  <teleport to="body">
    <register-confirm-modal ref="confirmModal" @register="doRegister" />
  </teleport>
</template>

<script>
import RegisterForm from "@/views/templates/forms/RegisterForm";
import FormCaption from '@/views/atoms/FormCaption'
import VuexTextFormItem from "@/views/molecules/formItems/VuexTextFormItem";
import VuexEmailFormItem from "@/views/molecules/formItems/VuexEmailFormItem";
import VuexLicenceFormItem from "@/views/molecules/formItems/VuexLicenceFormItem";
import VuexPostalCodeFormItem from "@/views/molecules/formItems/VuexPostalCodeFormItem";
import VuexPrefectureFormItem from "@/views/molecules/formItems/VuexPrefectureFormItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import RegisterConfirmModal from "@/views/molecules/modals/RegisterConfirmModal";
import VuexSelectFormItem from "@/views/molecules/formItems/VuexSelectFormItem";

export default {
  name: "GuestRegister",
  components: {
    RegisterForm,
    FormCaption,
    VuexTextFormItem,
    VuexEmailFormItem,
    VuexLicenceFormItem,
    VuexPostalCodeFormItem,
    VuexPrefectureFormItem,
    VuexTextareaFormItem,
    RegisterConfirmModal,
    VuexSelectFormItem,
  },
  inject: [
    '$constant',
  ],
  provide: {
    bindModule: 'guest_register_form'
  },
  computed: {
    pageTitle() {
      return this.$store.state.pageTitle;
    },
  },
  mounted() {
    this.$store.commit('guest_register_form/resetData');
    this.$store.commit('guest_register_form/clearError');
  },
  methods: {
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doRegister() {
      this.$store.commit('guest_register_form/setManagementCompanyCode', localStorage.getItem('managementCompanyCode'));
      this.$store.dispatch('guest_register_form/register', {guestType: this.$constant.GUEST_TYPE.BROKER.code}).then(() => {
        this.$router.push({name: 'GuestRegisterComplete'});
      }).catch(reason => this.$root.failApi(reason));
    },
    toPrivacyPolicy() {
      this.$router.push({name: 'PrivacyPolicyAgreement'});
    },
  }
}
</script>
